import React, {Component} from 'react';
import {Button} from 'antd';

import CameraModalForm from './CameraModalForm'

class CameraButtonCreate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleCreate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onCreate(values)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {camera, categories, type, style, text, ghost} = this.props
    return (<span>
      <Button type={type} style={style} icon="plus" ghost={ghost} onClick={this.showModal}>{text}</Button>
      <CameraModalForm title="Thêm mới camera" camera={camera} categories={categories} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleCreate}/>
    </span>);
  }
}

export default CameraButtonCreate;



// WEBPACK FOOTER //
// ./src/components/CameraButtonCreate.js